import { render } from "./BeneficiosPage.vue?vue&type=template&id=7618af2e&scoped=true&ts=true"
import script from "./BeneficiosPage.vue?vue&type=script&lang=ts"
export * from "./BeneficiosPage.vue?vue&type=script&lang=ts"

import "./BeneficiosPage.vue?vue&type=style&index=0&id=7618af2e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7618af2e"]])

export default __exports__